import { createResponseSchema } from '@mint-sdk/api-core';
import z from 'zod';

const EntityOptionSchema = z.object({
  id: z.string(),
  label: z.string(),
});

const UseAsEnum = z.enum(['full_value', 'abbreviation']);

export const EntitySchema = z.object({
  entityOption: EntityOptionSchema,
  useAs: UseAsEnum.nullable(),
  prefix: z.string().nullable(),
  separator: z.string(),
  defaultValue: z.string().nullable(),
});

export const EntityRequestSchema = EntitySchema.omit({
  entityOption: true,
}).extend({
  entityOptionId: z.string(),
});

export const NamingConventionSchema = z.object({
  id: z.string(),
  name: z.string(),
  companyId: z.number(),
  type: z.enum(['trafficking']),
  createdAt: z.string(),
  updatedAt: z.string().nullable(),
  userId: z.number().nullable(),
  userUpdatedAt: z.string().nullish(),
  entitiesSchema: z.array(EntitySchema),
});

export const NamingConventionQuerySchema = z.object({
  type: z.enum(['trafficking']).optional(),
});
export const NamingConventionResponseSchema = createResponseSchema(
  NamingConventionSchema,
);

export const NamingConventionCreateRequestSchema = NamingConventionSchema.pick({
  name: true,
  type: true,
}).extend({
  entitiesSchema: z.array(EntityRequestSchema),
});

export const NamingConventionUpdateRequestSchema = NamingConventionSchema.pick({
  name: true,
}).extend({
  entitiesSchema: z.array(EntityRequestSchema),
});

export const NamingConventionEntityOptionsResponseSchema =
  createResponseSchema(EntityOptionSchema);

export const NamingConventionSeparatorsResponseSchema = createResponseSchema(
  z.string(),
);
